// import React from 'react
// import MasterLayout from '../../../masterLayout/MasterLayout'

// export default function PaidList() {
//   return (
//     <>
//     <MasterLayout>
//     PaidList

//     </MasterLayout>
//     </>

//   )
// }

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import { Box, Tooltip, IconButton, Modal, Button } from "@mui/material";
import { Icon } from "@iconify/react";
// import { baseUrl } from "../../helper/urls";
// import AdminCustomTable from "../../components/custom_table/AdminCustomTable";
// import ApproveSlotRequest from "./ApproveSlotRequest";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl } from "../../../helper/urls";
import ApproveSlotRequest from "../../Request/ApproveSlotRequest";
import AdminCustomTable from "../../../components/custom_table/AdminCustomTable";
import MasterLayout from "../../../masterLayout/MasterLayout";

const MySwal = withReactContent(Swal);

const PaidList = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");

  const formatDateToLocalYYYYMMDD = (date) => {
    if (!date) return "";
    const d = new Date(date); // safe if date is already a string
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchBookingReq = async (
    startDateParam = null,
    endDateParam = null
    // statusParam = "2"
  ) => {
    try {
      const params = new URLSearchParams();

      if (startDateParam) {
        params.append("startDate", formatDateToLocalYYYYMMDD(startDateParam));
      }
      if (endDateParam) {
        params.append("endDate", formatDateToLocalYYYYMMDD(endDateParam));
      }
      // if (statusParam !== "") {
      //   params.append("status", statusParam);
      // }
      params.append("status", "2");

      const queryString = params.toString();
      const apiUrl = queryString
        ? `${baseUrl}/api/booking_req/byAdmin?${queryString}`
        : `${baseUrl}/api/booking_req/byAdmin`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setBookings(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching booking requests:", error);
      setError("Failed to fetch booking requests");
      setLoading(false);
    }
  };

  const handleDateFilter = () => {
    setLoading(true);
    fetchBookingReq(startDate, endDate, statusFilter); // These can be Date objects or strings
  };

  const handleClearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setStatusFilter("");
    setLoading(true);
    fetchBookingReq();
  };

  useEffect(() => {
    fetchBookingReq();
  }, []);

  const handleEditSlots = async (id, currentSlots) => {
    const booking = bookings.find((b) => b.id === id);
    console.log(booking, bookings, id, "booking");
    const basePrice = Number.parseFloat(booking?.counselorPrice_per_hour || 0);
    const commissionPercent = Number.parseFloat(
      booking?.counselorCommission_per || 0
    );

    const pricePerHour = basePrice + (commissionPercent / 100) * basePrice;
    const { isConfirmed, value } = await Swal.fire({
      title: '<h5 style="font-size: 14px; margin: 0;">Approved Slots</h5>',
      html: `
      <div style=" font-size: 13px;">
          <div style="display: flex; align-items: center; justify-content: space-between;">
    <label for="slotsInput">Add Slots</label>
    <input type="number" id="slotsInput" class="swal2-input" value="${
      currentSlots || ""
    }" min="1" placeholder="e.g. 5" />
  </div>
  <div style="display: flex; align-items: center; justify-content: space-between;">
    <label for="discountInput">Discount (%)</label>
    <input type="number" id="discountInput" class="swal2-input" value="0" min="0" max="100" />
  </div>
        <div id="booking-summary" style="text-align:left; font-size:14px; margin-top: 10px;">
          <div style="display: flex; justify-content: space-between; margin: 5px 0;"><strong>Price/hour:</strong> <span>$${pricePerHour.toFixed(
            2
          )}</span></div>
          <div style="display: flex; justify-content: space-between; margin: 5px 0;"><strong>Discount:</strong> <span id="discountAmount">- $0.00</span></div>
          <hr style="border: 2px solid #000; margin: 10px 0 5px;" />
          <div style="display: flex; justify-content: space-between; font-weight:bold; margin-top: 10px;">
            <span>Final Price:</span> <span id="finalPrice">$0.00</span>
          </div>
        </div>
      </div>
    `,
      focusConfirm: false,
      preConfirm: () => {
        const slots = Number.parseInt(
          document.getElementById("slotsInput").value
        );
        const discountPercent = Number.parseFloat(
          document.getElementById("discountInput").value
        );

        if (!slots || slots <= 0) {
          Swal.showValidationMessage(
            "Please enter a valid number greater than 0"
          );
          return;
        }

        const totalAmount = pricePerHour * slots;
        const discountAmount = (discountPercent / 100) * totalAmount;
        const finalPrice = Math.max(totalAmount - discountAmount, 0);

        const baseSubtotal = basePrice * slots;
        const commissionAmount = totalAmount - baseSubtotal;

        return {
          approved_slots: slots,
          discount_percentage: discountPercent, // ✅ Add this line
          discount_amount: discountAmount,
          total_amount: Number.parseFloat(finalPrice.toFixed(2)),
          counselor_amount: Number.parseFloat(baseSubtotal.toFixed(2)),
          admin_amount: Number.parseFloat(commissionAmount.toFixed(2)),
          counselorId: booking.counselorId,
          studentId: booking.studentId,
          id: booking.id,
        };
      },
      didOpen: () => {
        const slotsInput = document.getElementById("slotsInput");
        const discountInput = document.getElementById("discountInput");

        const updateSummary = () => {
          const slots = Number.parseInt(slotsInput.value) || 0;
          const discountPercent = Number.parseFloat(discountInput.value) || 0;

          const totalAmount = pricePerHour * slots;
          const discountAmount = (discountPercent / 100) * totalAmount;
          const finalPrice = Math.max(totalAmount - discountAmount, 0);

          document.getElementById(
            "discountAmount"
          ).textContent = `- $${discountAmount.toFixed(2)}`;
          document.getElementById(
            "finalPrice"
          ).textContent = `$${finalPrice.toFixed(2)}`;
        };

        slotsInput.addEventListener("input", updateSummary);
        discountInput.addEventListener("input", updateSummary);
        updateSummary(); // Initial summary
      },
      confirmButtonText: "Send Payment Link",
      showCancelButton: true,
      cancelButtonText: "Cancel",
    });

    if (!isConfirmed || !value) return;

    try {
      await axios.post(`${baseUrl}/api/booking_req/update/${id}`, value, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.fire("Success", "Approved slots updated successfully", "success");
      setStatusFilter("");
      fetchBookingReq();
    } catch (error) {
      Swal.fire("Error", "Failed to update approved slots", "error");
      console.error("Update Error:", error);
    }
  };

  const statusMap = {
    0: "Pending",
    1: "Unpaid",
    2: "Paid",
    3: "Completed",
    4: "Cancelled",
  };

  const statusMapType = {
    0: "warning",
    1: "error",
    2: "success",
    3: "default",
    4: "info",
  };

  const [rowData, setrowData] = useState(null);
  console.log("rowData: ", rowData);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("Action", {
      header: "Action",
      size: 20,
      Cell: (cell) => {
        const row = cell.row.original;
        const {
          payment_link,
          status,
          Unscheduled,
          approved_slots,
          Scheduled,
          discount_amount,
          total_amount,
          amountBeforeDiscount,
          counselorPricePerHour,
          counselorinterestedIn,
        } = row;

        // if (approved_slots === Scheduled) {
        //   return (
        //     <Button variant="contained" size="small" disabled>
        //       All Slots are Scheduled
        //       {/* All Slots Booked */}
        //     </Button>
        //   );
        // }
        if (Unscheduled == 0) {
          return (
            <Button variant="contained" size="small" disabled>
              All Slots are Scheduled
              {/* All Slots Booked */}
            </Button>
          );
        }

        // if (status === 1 && payment_link) {
        // if (status === 1) {
        //   return (
        //     <Button
        //       variant="contained"
        //       size="small"
        //       sx={{ backgroundColor: "#124178", color: "white" }}
        //       // onClick={() => handleOpen3({ row })}
        //       // onClick={() => window.open(payment_link, "_blank")}
        //     >
        //       Pay Now
        //     </Button>
        //   );
        // }

        if (Unscheduled > 0) {
          return (
            <Button
              variant="contained"
              size="small"
              color="success"
              // sx={{ backgroundColor: "#28a745", color: "white" }}
              onClick={() => {
                navigate("/student-slot-booking-by-admin", {
                  state: {
                    counselorId: row.counselorId,
                    studentId: row.studentId,
                    reqId: row.id,
                    UnscheduledSlot: row.Unscheduled,
                  },
                  // state: { row },
                });
              }}
            >
              Book Slot
            </Button>
          );
        }

        return null;
      },
    }),
    // columnHelper.accessor("Actions", {
    //   header: "Actions",
    //   Cell: ({ cell }) => {
    //     const row = cell.row.original;
    //     const {
    //       id,
    //       approved_slots,
    //       counselorPrice_per_hour,
    //       counselorCommission_per,
    //       status,
    //     } = row;

    //     return (
    //       <>
    //         <Box>
    //           {status == 0 && (
    //             <>
    //               {/* <button
    //                 onClick={() =>
    //                   handleEditSlots(
    //                     id,
    //                     approved_slots,
    //                     counselorPrice_per_hour,
    //                     counselorCommission_per
    //                   )
    //                 }
    //                 className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
    //                 style={{ cursor: "pointer" }}
    //                 title="Edit Slots"
    //               >
    //                 <Icon icon="lucide:edit" />
    //               </button> */}
    //               <Tooltip title="Edit" arrow>
    //                 <button
    //                   // onClick={() =>
    //                   //   handleEditSlots(
    //                   //     id,
    //                   //     approved_slots,
    //                   //     counselorPrice_per_hour,
    //                   //     counselorCommission_per
    //                   //   )
    //                   // }
    //                   onClick={() => {
    //                     handleOpen();
    //                     setrowData(row);
    //                   }}
    //                   className="w-32-px h-32-px me-8 bg-info-focus text-info-main
    //                 rounded-circle d-inline-flex align-items-center
    //                 justify-content-center"
    //                   style={{ cursor: "pointer" }}
    //                   title="Edit Slots"
    //                 >
    //                   <Icon icon="lucide:edit" />
    //                 </button>
    //               </Tooltip>
    //               <Tooltip title="Cancel" arrow>
    //                 <button
    //                   onClick={() => {
    //                     Swal.fire({
    //                       html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
    //                       text: "You won't be able to revert this cancellation!",
    //                       icon: "question",
    //                       showCancelButton: true,
    //                       confirmButtonColor: "#d33",
    //                       cancelButtonColor: "#3085d6",
    //                       confirmButtonText: "Yes, cancel it!",
    //                     }).then((result) => {
    //                       if (result.isConfirmed) {
    //                         cancelBooking(id);
    //                       }
    //                     });
    //                   }}
    //                   className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
    //                   style={{ cursor: "pointer" }}
    //                 >
    //                   <Icon icon="ic:round-close" />
    //                 </button>
    //               </Tooltip>

    //               {/* <Button onClick={handleOpen}>Open modal</Button> */}
    //             </>
    //           )}
    //           {status == 1 && (
    //             <button
    //               className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
    //               style={{ cursor: "pointer" }}
    //               title="Send link"
    //               onClick={() => handleSendLink(id)}
    //             >
    //               <Icon icon="lucide:send" />
    //             </button>
    //           )}
    //         </Box>
    //       </>
    //     );
    //   },
    // }),

    columnHelper.accessor("status", {
      header: "Status",
      Cell: (cell) => {
        const status = cell.row.original?.status;
        return (
          <Chip
            label={statusMap[status]}
            color={statusMapType[status]}
            variant="contained"
          />
        );
      },
    }),

    columnHelper.accessor("payment_link", {
      header: "Payment Link",
      Cell: (cell) => {
        const link = cell.row.original?.payment_link;

        const copyToClipboard = () => {
          if (link) {
            navigator.clipboard.writeText(link);
          }
        };

        return link ? (
          <Tooltip title={link}>
            <IconButton onClick={copyToClipboard} size="small" color="primary">
              <Icon icon="lucide:copy" />
            </IconButton>
          </Tooltip>
        ) : (
          "-"
        );
      },
    }),

    columnHelper.accessor("studentId", {
      header: "Student Name",
      Cell: (cell) =>
        `${cell.row.original?.studentFirstName || ""} ${
          cell.row.original?.studentLastName || ""
        }`,
    }),

    columnHelper.accessor("studentEmail", {
      header: "Student Email",
      Cell: (cell) => cell.row.original?.studentEmail || "-",
    }),
    columnHelper.accessor("studentPhone", {
      header: "Student Phone",
      Cell: ({ row }) => {
        const phone = row.original?.studentPhone;
        const countryCode = row.original?.studentCountryCode;
        return phone ? `${countryCode} ${phone}` : "-";
      },
    }),

    columnHelper.accessor("call_time", {
      header: "Call Time",
      Cell: (cell) => cell.row.original?.call_time || "-",
    }),
    columnHelper.accessor("counselorId", {
      header: "Counselor Name",
      Cell: (cell) =>
        `${cell.row.original?.counselorFirstName || ""} ${
          cell.row.original?.counselorLastName || ""
        }`,
    }),
    columnHelper.accessor("counselorEmail", {
      header: "Counselor Email",
      Cell: (cell) => cell.row.original?.counselorEmail || "-",
    }),
    columnHelper.accessor("counselorPhone", {
      header: "Counselor Phone",
      Cell: ({ row }) => {
        const phone = row.original?.counselorPhone;
        const countryCode = row.original?.counselorCountryCode;
        return phone ? `${countryCode} ${phone}` : "-";
      },
    }),
    columnHelper.accessor("counselorinterestedIn", {
      header: "Service Type",
      Cell: (cell) => cell.row.original?.counselorinterestedIn || "-",
    }),
    columnHelper.accessor("description", {
      header: "Description",
      Cell: (cell) => cell.row.original?.description || "-",
    }),

    columnHelper.accessor("counselorPrice_per_hour", {
      header: "Price/hour ($)",
      Cell: (cell) => cell.row.original?.counselorPrice_per_hour || "-",
    }),
    columnHelper.accessor("counselorCommission_per", {
      header: "Commission (%)",
      Cell: (cell) => cell.row.original?.counselorCommission_per || "-",
    }),
    columnHelper.accessor("approved_slots", {
      header: "Confirmed Slots",
      Cell: (cell) => cell.row.original?.approved_slots ?? "-",
    }),
    columnHelper.accessor("scheduled", {
      header: "Scheduled Slots",
      Cell: (cell) => cell.row.original?.scheduled ?? "-",
    }),
    columnHelper.accessor("Unscheduled", {
      header: "Pending Slots",
      Cell: (cell) => cell.row.original?.Unscheduled ?? "-",
    }),
    columnHelper.accessor("total_amount", {
      header: "Total Amount ($)",
      Cell: (cell) => cell.row.original?.total_amount ?? "-",
    }),
    columnHelper.accessor("discount_amount", {
      header: "Discount Amount ($)",
      Cell: (cell) => cell.row.original?.discount_amount ?? "-",
    }),
    columnHelper.accessor("discount_percentage", {
      header: "Discount (%)",
      Cell: (cell) => cell.row.original?.discount_percentage ?? "-",
    }),

    columnHelper.accessor("created_at", {
      header: "Date",
      Cell: (cell) => {
        const dateStr = cell.row.original?.created_at;
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      },
    }),
    columnHelper.accessor((row) => `DDR000${row.id}`, {
      id: "id",
      header: "Request ID",
      size: 30,
    }),
  ];

  const cancelBooking = async (id) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/booking_req/cancel/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Show success message
      toast.success("Booking cancelled successfully!");
      fetchBookingReq();
    } catch (error) {
      console.error("Failed to load price list", error);
    }
  };

  const styles = {
    container: {
      display: "flex",
      flexWrap: "wrap",
      gap: "12px",
      padding: "16px",
      background: "#fff",
      borderRadius: "8px",
      marginBottom: "20px",
      alignItems: "flex-end",
    },
    group: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    label: {
      fontSize: "14px",
      fontWeight: 500,
      color: "#333",
    },
    input: {
      padding: "6px 10px",
      fontSize: "14px",
      height: "36px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      minWidth: "180px",
    },
    iconButton: {
      width: "36px",
      height: "36px",
      border: "none",
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      transition: "0.2s ease-in-out",
    },
    primary: {
      backgroundColor: "#e3f2fd",
      color: "#1976d2",
    },
    primaryHover: {
      backgroundColor: "#bbdefb",
    },
    secondary: {
      backgroundColor: "#fce4ec",
      color: "#d32f2f",
    },
    secondaryHover: {
      backgroundColor: "#f8bbd0",
    },
  };

  const handleSendLink = async (id) => {
    const result = await Swal.fire({
      html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
      text: "Do you want to send the email?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.get(
          `${baseUrl}/api/booking_req/resend/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        Swal.fire("Sent!", "The email has been sent.", "success");
      } catch (err) {
        console.error("Failed to fetch pending booking list", err);
        setError("Failed to fetch pending bookings. Please try again later.");
        Swal.fire("Error", "Failed to send the email.", "error");
      } finally {
      }
    }
  };

  return (
    <>
      <MasterLayout>
        <ToastContainer position="top-right" autoClose={3000} />
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 600,
              bgcolor: "background.paper",
              border: "1px solid #fff",
              boxShadow: 24,
              p: 2,
            }}
          >
            <Box sx={{ p: 2 }}>
              <ApproveSlotRequest
                rowData={rowData}
                handleClose={handleClose}
                fetchBookingReq={fetchBookingReq}
              />
            </Box>
            {/* <CounselorRatesForm /> */}
          </Box>
        </Modal>

        {/* Date Filter Section */}
        <div style={styles.container}>
          {/* <div style={styles.group}>
            <label style={styles.label}>Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={styles.input}
            >
              <option value="">All</option>
              {Object.entries(statusMap).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div> */}

          <div style={styles.group}>
            <label style={styles.label}>Start Date</label>
            <input
              type="date"
              value={startDate}
              max={endDate || ""}
              onChange={(e) => setStartDate(e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.group}>
            <label style={styles.label}>End Date</label>
            <input
              type="date"
              value={endDate}
              min={startDate || ""}
              onChange={(e) => setEndDate(e.target.value)}
              style={styles.input}
            />
          </div>

          <button
            style={{
              ...styles.iconButton,
              ...styles.primary,
            }}
            onClick={handleDateFilter}
            disabled={loading}
            title="Apply Filter"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.primaryHover.backgroundColor;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.primary.backgroundColor;
            }}
          >
            <Icon icon="material-symbols:search" />
          </button>

          <button
            style={{
              ...styles.iconButton,
              ...styles.secondary,
            }}
            onClick={handleClearFilter}
            disabled={loading}
            title="Clear Filter"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.secondaryHover.backgroundColor;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.secondary.backgroundColor;
            }}
          >
            <Icon icon="material-symbols:cancel-outline-rounded" />
          </button>
        </div>
        <AdminCustomTable columns={columns} data={bookings} loading={loading} />
      </MasterLayout>
    </>
  );
};

export default PaidList;
